module.exports = __webpack_public_path__ + "img/iot-04.06a1211b.png";